import { useEffect, useState } from "react";
import { getAllRelations } from "../services/guest";

export const useRelationOptions = () => {
  const [relationOptions, setRelationOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchRelations = async () => {
 
    setLoading(true);
    try {
      const response = await getAllRelations();
    const relations = response?.data || [];
      setRelationOptions(relations);
    } catch (error) {
      console.error("Error fetching relations", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRelations();
  }, []);

  return { relationOptions, loading, fetchRelations };
};
